
import React, { useEffect } from 'react';
import { setTitle } from '../../shared/services/general/general-service';
import './terms.scss';
import Footer from '../../components/footer/footer';
import { useConfigApp } from '../../shared/services/general/app-context';
export default function Terms () {
	const configApp = useConfigApp();
	useEffect(() => {
		setTitle('قوانین');
	}, []);

	return (<>

        <div className='terms'>
        <div class="max-width-menu section-title clearfix"><h1>شرایط استفاده</h1></div>
        <br />
			این سرویس با نام تجاری "{configApp?.title}" ثبت گردیده است و از حق کپی‌رایت برخوردار است. اگر در سایت‌های دیگر با موارد نقض کپی‌رایت {configApp?.title} مواجه شدید، لطفاً آن را به سرویس پشتیبانی «{configApp?.title}» به آدرس ایمیل info@bebin.com زیر اطلاع دهید. تمامی محتواهای ارائه شده در سرویس ببین در چارچوب قوانین و مقررات جمهوری اسلامی ایران است.

			کلیه اطلاعات کاربران نزد "{configApp?.title}" امانت بوده و متعهد و مکلف به حفظ اطلاعات شخصی کاربران می باشیم.

			"{configApp?.title}" دارای مجوزهای لازم از مراجع ذی صلاح بوده و به همین علت محتوای موجود، مناسب تمامی رده های سنی با نظر والدین می باشد.
        </div>
      {/*  <div className='termss'>*/}
      {/*  <div class="max-width-menu section-title clearfix"><h1>حریم خصوصی </h1></div>*/}
      {/*  <p>*/}
      {/*  از آنجا که حریم خصوصی کاربران برای ما بسیار حائز اهمیت است، ما در {configApp?.title} تمام تلاش خود را برای حفظ حریم خصوصی شما انجام می‌دهیم. به همین منظور، در اینجا به شما توضیح می‌دهیم که چگونه با اطلاعات شما برخورد و از آن محافظت می شود.*/}
      {/*</p>*/}
      {/*<br />*/}
      {/*<p>*/}
      {/*  تضمین حریم خصوصی کاربرانی که با سایت {configApp?.title} در ارتباط هستند، برای ما بسیار مهم است. این به این معنی است که اطلاعات شما همواره محرمانه باقی می‌ماند و تنها در صورت الزام قانون به اشتراک گذاشته می‌شود. هیچ گونه اطلاعاتی از کاربران در اختیار شرکت‌ها و سازمان‌های دیگر قرار نمی‌گیرد.*/}
      {/*</p>*/}
      {/*<br />*/}
      {/*<p>*/}
      {/*  اطلاعاتی که شما در اختیار {configApp?.title} قرار می‌دهید بدین‌گونه است که در فرآیند ثبت‌نام، اطلاعات مربوط به کاربر شامل آدرس ایمیل و شماره تلفن همراه دریافت می‌گردد و در پایان شماره ای جهت احراز هویت کاربر به آدرس ایمیل یا شماره اعلام شده از طرف وی فرستاده می‌شود. در صورت ثبت‌نام، با استفاده از نام کاربری در {configApp?.title} اطلاعاتی از قبیل "فهرست سابقه خرید"، "ویرایش اطلاعات حساب کاربری" و "لیست شخصی" نمایش داده می‌شوند. در قسمت ویرایش اطلاعات حساب کاربری، کاربر قادر است تا در صورت تمایل، اطلاعاتی نظیر "نام و نام خانوادگی"، "ایمیل" و "رمز عبور" را به‌روزرسانی کند.*/}
      {/*</p>*/}
      {/*<br />*/}
      {/*<p>*/}
      {/*  {configApp?.title} اطلاعاتی که از حساب کاربران به طور خودکار بدست می‌آورد جهت تحلیل، بررسی و شخصی‌سازی خدمات خود و ارائه پیشنهادات ویژهٔ نزدیک‌تر به سلیقه کاربران استفاده خواهد کرد. این اطلاعات به {configApp?.title} کمک می‌کند تا سرویس خود را بهبود بخشیده و محتوای مرتبط‌تری با علایق هر کاربر به ایشان ارائه کند.*/}
      {/*</p>*/}
      {/*<br />*/}
      {/*<p>*/}
      {/*  در صورتی که سوالی درباره حریم خصوصی دارید، با آدرس زیر در ارتباط باشید:*/}
      {/*  <a href="mailto:contact@example.com">info@bebin.com</a>*/}
      {/*</p>*/}
      {/*<br />*/}
      {/*  </div>*/}
		<Footer></Footer>
    </>
      
	);
}
